import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const guardiansManagement = createApi({
    reducerPath: "guardiansManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        guardiansList: builder.mutation({
            query: ({ filters, studentId }) => {
                let url = `v1/${locale}/students/${studentId}/guardians`;

                for (const property in filters) {
                    if (property && filters[property]) {
                        if (url?.includes("?")) {
                            url += `&${property}=${filters[property]}`;
                        } else {
                            url += `?${property}=${filters[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewGuardian: builder.mutation({
            query: ({ studentId, guardianId }) => ({
                url: `v1/${locale}/students/${studentId}/guardians/${guardianId}`,
                method: "GET",
            }),
        }),
        addGuardian: builder.mutation({
            query: ({ body, studentId }) => ({
                url: `v1/${locale}/students/${studentId}/guardians`,
                method: "POST",
                body: body,
            }),
        }),
        updateGuardian: builder.mutation({
            query: ({ body, studentId, guardianId }) => ({
                url: `v1/${locale}/students/${studentId}/guardians/${guardianId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        deleteGuardian: builder.mutation({
            query: ({ studentId, guardianId }) => ({
                url: `v1/${locale}/students/${studentId}/guardians/${guardianId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {useGuardiansListMutation, useAddGuardianMutation, useUpdateGuardianMutation, useDeleteGuardianMutation, useViewGuardianMutation} = guardiansManagement;
